// // import { useState } from 'react';
// // import { ShoppingCart, ChevronDown, Menu, X } from 'lucide-react';

// // export default function HomeWaterFiltration() {
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// //   return (
// //     <div className="min-h-screen bg-white">
// //       {/* Navigation */}
// //       <nav className="bg-blue-500 py-4 px-6 md:px-12">
// //         <div className="max-w-7xl mx-auto flex items-center justify-between">
// //           <div className="flex items-center">
// //             <a href="#" className="flex items-center">
// //               <div className="text-white bg-blue-600 rounded-full p-2 mr-2">
// //                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
// //                 </svg>
// //               </div>
// //               <div>
// //                 <h1 className="text-white text-xl font-bold">Home Water Filtration</h1>
// //                 <p className="text-blue-100 text-xs">Pure, clean water for you</p>
// //               </div>
// //             </a>
// //           </div>

// //           {/* Desktop Navigation */}
// //           <div className="hidden md:flex items-center space-x-6">
// //             <a href="#" className="text-white hover:text-blue-100">Home</a>
// //             <div className="relative group">
// //               <button className="flex items-center text-white hover:text-blue-100">
// //                 About us <ChevronDown size={16} className="ml-1" />
// //               </button>
// //               <div className="absolute hidden group-hover:block bg-white shadow-lg rounded-md p-2 mt-1 z-10">
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Our Story</a>
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Mission</a>
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Team</a>
// //               </div>
// //             </div>
// //             <div className="relative group">
// //               <button className="flex items-center text-white hover:text-blue-100">
// //                 Our Products <ChevronDown size={16} className="ml-1" />
// //               </button>
// //               <div className="absolute hidden group-hover:block bg-white shadow-lg rounded-md p-2 mt-1 z-10">
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Whole House Systems</a>
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Under-Sink Filters</a>
// //                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded">Replacement Parts</a>
// //               </div>
// //             </div>
// //             <a href="#" className="text-white hover:text-blue-100">Shop</a>
// //             <a href="#" className="text-white hover:text-blue-100">Contact Us</a>
// //             <a href="#" className="bg-white text-blue-500 px-4 py-2 rounded-md font-medium hover:bg-blue-100 transition">Request a Quote</a>
// //             <a href="#" className="text-white hover:text-blue-100">
// //               <ShoppingCart size={20} />
// //             </a>
// //           </div>

// //           {/* Mobile menu button */}
// //           <div className="md:hidden">
// //             <button
// //               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// //               className="text-white hover:text-blue-100 focus:outline-none"
// //             >
// //               {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
// //             </button>
// //           </div>
// //         </div>

// //         {/* Mobile menu */}
// //         {mobileMenuOpen && (
// //           <div className="md:hidden mt-4 bg-blue-600 rounded-lg p-4">
// //             <a href="#" className="block text-white py-2">Home</a>
// //             <a href="#" className="block text-white py-2">About us</a>
// //             <a href="#" className="block text-white py-2">Our Products</a>
// //             <a href="#" className="block text-white py-2">Shop</a>
// //             <a href="#" className="block text-white py-2">Contact Us</a>
// //             <a href="#" className="block bg-white text-blue-500 px-4 py-2 rounded-md font-medium mt-2">Request a Quote</a>
// //           </div>
// //         )}
// //       </nav>

// //       {/* Hero Section */}
// //       <div className="bg-blue-500 py-20 px-6 md:px-12 relative overflow-hidden">
// //         <div className="max-w-7xl mx-auto">
// //           <h1 className="text-white text-4xl md:text-6xl font-bold mb-6">HOME WATER FILTRATION.</h1>
// //           <h2 className="text-white text-2xl md:text-3xl mb-12">A water filter with a difference</h2>
// //           <button className="bg-white text-blue-500 px-6 py-3 rounded-md font-medium hover:bg-blue-100 transition">
// //             Request A Quote
// //           </button>
// //         </div>
        
// //         {/* Wave effect */}
// //         <div className="absolute bottom-0 left-0 right-0">
// //           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
// //             <path fill="white" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,154.7C672,192,768,224,864,213.3C960,203,1056,149,1152,117.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
// //           </svg>
// //         </div>
// //       </div>

// //       {/* Info Section */}
// //       <div className="py-16 px-6 md:px-12 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <h2 className="text-gray-800 text-3xl md:text-4xl font-bold mb-8">Do you know what's in your tap water?</h2>
// //           <p className="text-gray-600 text-lg mb-8">
// //             In Australia we have up to 50 chemicals added to our water. While this is essential to 
// //             make water safe to drink, some contaminants like chlorine and aluminium can 
// //             cause health issues over time.
// //           </p>

// //           <div className="flex flex-col md:flex-row items-center gap-12">
// //             <div className="md:w-1/2">
// //               <img 
// //                 src="/api/placeholder/600/400" 
// //                 alt="People concerned about water quality" 
// //                 className="rounded-lg"
// //               />
// //             </div>

// //             <div className="md:w-1/2 mt-8 md:mt-0">
// //               <div className="bg-blue-50 p-6 rounded-lg">
// //                 <h3 className="text-gray-700 text-xl font-semibold mb-4">
// //                   Behavioural problems, hypertension, mental health problems, learning difficulties, confusion, dry and itchy skin, brittle hair —
// //                 </h3>
// //                 <p className="text-gray-600 mb-6">
// //                   these are all side effects from nasty tap water.
// //                 </p>
// //                 <p className="text-gray-600 mb-6">
// //                   Then there's the problem with calcium and limescale build up. This reduces the life of appliances and often requires the use of heavy-duty cleaning products, which is bad for the environment.
// //                 </p>
// //                 <button className="bg-blue-500 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition">
// //                   Contact Us
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Features Section */}
// //       <div className="py-16 px-6 md:px-12 bg-gray-50">
// //         <div className="max-w-7xl mx-auto">
// //           <h2 className="text-gray-800 text-3xl font-bold mb-12 text-center">Why Choose Our Water Filters?</h2>
          
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
// //             <div className="bg-white p-6 rounded-lg shadow-md">
// //               <div className="bg-blue-100 text-blue-500 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
// //                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
// //                 </svg>
// //               </div>
// //               <h3 className="text-gray-800 text-xl font-semibold mb-3">Advanced Filtration</h3>
// //               <p className="text-gray-600">Our multi-stage filtration systems remove up to 99.9% of contaminants, including chlorine, heavy metals, and microplastics.</p>
// //             </div>
            
// //             <div className="bg-white p-6 rounded-lg shadow-md">
// //               <div className="bg-blue-100 text-blue-500 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
// //                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
// //                 </svg>
// //               </div>
// //               <h3 className="text-gray-800 text-xl font-semibold mb-3">Long-Lasting</h3>
// //               <p className="text-gray-600">Our filters are designed to last 2-3 times longer than competitors, saving you money on replacements and maintenance.</p>
// //             </div>
            
// //             <div className="bg-white p-6 rounded-lg shadow-md">
// //               <div className="bg-blue-100 text-blue-500 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
// //                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z" />
// //                 </svg>
// //               </div>
// //               <h3 className="text-gray-800 text-xl font-semibold mb-3">Easy Installation</h3>
// //               <p className="text-gray-600">Our systems are designed for simple installation and maintenance, with comprehensive instructions and customer support.</p>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Testimonials Section */}
// //       <div className="py-16 px-6 md:px-12 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <h2 className="text-gray-800 text-3xl font-bold mb-12 text-center">What Our Customers Say</h2>
          
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
// //             <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
// //               <div className="flex mb-4">
// //                 {[1, 2, 3, 4, 5].map((star) => (
// //                   <svg key={star} className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
// //                     <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
// //                   </svg>
// //                 ))}
// //               </div>
// //               <p className="text-gray-600 mb-4">"Since installing the whole house filter system, we've noticed a huge difference in our water quality. My skin isn't dry anymore, and our appliances are lasting longer!"</p>
// //               <p className="font-semibold">- Sarah Johnson, Brisbane</p>
// //             </div>
            
// //             <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
// //               <div className="flex mb-4">
// //                 {[1, 2, 3, 4, 5].map((star) => (
// //                   <svg key={star} className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
// //                     <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
// //                   </svg>
// //                 ))}
// //               </div>
// //               <p className="text-gray-600 mb-4">"The installation was so easy, and the customer service team was incredible. They walked me through every step of the process. Best investment we've made for our home."</p>
// //               <p className="font-semibold">- Michael Chen, Sydney</p>
// //             </div>
            
// //             <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
// //               <div className="flex mb-4">
// //                 {[1, 2, 3, 4, 5].map((star) => (
// //                   <svg key={star} className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
// //                     <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
// //                   </svg>
// //                 ))}
// //               </div>
// //               <p className="text-gray-600 mb-4">"Our water tastes amazing now! No more bottled water for us. I also love that we're reducing plastic waste while getting healthier water for our family."</p>
// //               <p className="font-semibold">- Lisa Anderson, Melbourne</p>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* CTA Section */}
// //       <div className="py-16 px-6 md:px-12 bg-blue-500 relative overflow-hidden">
// //         <div className="max-w-7xl mx-auto text-center">
// //           <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">Ready for cleaner, healthier water?</h2>
// //           <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
// //             Our expert team will help you find the perfect filtration solution for your home.
// //             Get in touch today for a free consultation and quote.
// //           </p>
// //           <div className="flex flex-col sm:flex-row gap-4 justify-center">
// //             <button className="bg-white text-blue-500 px-6 py-3 rounded-md font-medium hover:bg-blue-100 transition">
// //               Request a Quote
// //             </button>
// //             <button className="bg-transparent text-white border border-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition">
// //               Contact Us
// //             </button>
// //           </div>
// //         </div>
        
// //         {/* Wave effect */}
// //         <div className="absolute top-0 left-0 right-0 transform rotate-180">
// //           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
// //             <path fill="white" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,154.7C672,192,768,224,864,213.3C960,203,1056,149,1152,117.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
// //           </svg>
// //         </div>
// //       </div>

// //       {/* Footer */}
// //       <footer className="bg-gray-800 text-white py-12 px-6 md:px-12">
// //         <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
// //           <div>
// //             <h3 className="text-xl font-bold mb-4">Home Water Filtration</h3>
// //             <p className="text-gray-400">Pure, clean water for you and your family. Australian owned and operated since 2010.</p>
// //           </div>
          
// //           <div>
// //             <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
// //             <ul className="space-y-2">
// //               <li><a href="#" className="text-gray-400 hover:text-white">Home</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">About Us</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Products</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Shop</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Contact</a></li>
// //             </ul>
// //           </div>
          
// //           <div>
// //             <h3 className="text-lg font-semibold mb-4">Products</h3>
// //             <ul className="space-y-2">
// //               <li><a href="#" className="text-gray-400 hover:text-white">Whole House Systems</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Under-Sink Filters</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Shower Filters</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Replacement Cartridges</a></li>
// //               <li><a href="#" className="text-gray-400 hover:text-white">Water Testing Kits</a></li>
// //             </ul>
// //           </div>
          
// //           <div>
// //             <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
// //             <ul className="space-y-2 text-gray-400">
// //               <li>123 Water Lane</li>
// //               <li>Sydney, NSW 2000</li>
// //               <li>Australia</li>
// //               <li>Phone: 1800 FILTER (345 837)</li>
// //               <li>Email: info@homewaterfiltration.com.au</li>
// //             </ul>
// //           </div>
// //         </div>
        
// //         <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-gray-700 text-center">
// //           <p className="text-gray-400">&copy; {new Date().getFullYear()} Home Water Filtration. All rights reserved.</p>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // }


// import { useState, useEffect } from 'react';
// import { ShoppingCart, ChevronDown, Menu, X, ArrowRight, Check, Droplet, Shield, Clock, Heart, User, Mail, Phone, MapPin } from 'lucide-react';

// export default function HomeWaterFiltration() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);

//   // Handle scroll effect on navbar
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 20) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   // Product data
//   const products = [
//     {
//       id: 1,
//       name: "Whole House Filtration System",
//       price: "$1,999",
//       image: "/api/placeholder/400/250",
//       rating: 5,
//       reviewCount: 124
//     },
//     {
//       id: 2,
//       name: "Under-Sink Advanced Filter",
//       price: "$499",
//       image: "/api/placeholder/400/250",
//       rating: 4.8,
//       reviewCount: 89
//     },
//     {
//       id: 3,
//       name: "Shower Filter System",
//       price: "$129",
//       image: "/api/placeholder/400/250",
//       rating: 4.9,
//       reviewCount: 216
//     }
//   ];

//   // Testimonial data
//   const testimonials = [
//     {
//       id: 1,
//       text: "The difference in water quality is incredible. My skin has never felt better, and our appliances are free from limescale buildup for the first time!",
//       name: "Sarah Johnson",
//       location: "Brisbane",
//       rating: 5,
//       avatar: "/api/placeholder/64/64"
//     },
//     {
//       id: 2,
//       text: "Installation was straightforward, and the customer support team was exceptional. They guided me through every step, making the process hassle-free.",
//       name: "Michael Chen",
//       location: "Sydney",
//       rating: 5,
//       avatar: "/api/placeholder/64/64"
//     },
//     {
//       id: 3,
//       text: "Our water tastes incredible now! We've eliminated plastic bottle waste and are saving money while enjoying healthier water. Highly recommended!",
//       name: "Lisa Anderson",
//       location: "Melbourne",
//       rating: 5,
//       avatar: "/api/placeholder/64/64"
//     }
//   ];

//   // Features data
//   const features = [
//     {
//       id: 1,
//       title: "Advanced Filtration Technology",
//       description: "Our proprietary multi-stage filtration system removes 99.9% of contaminants including chlorine, heavy metals, and microplastics.",
//       icon: <Droplet size={24} />,
//       color: "bg-blue-500"
//     },
//     {
//       id: 2,
//       title: "Superior Longevity",
//       description: "Designed to last 2-3 times longer than competing products, providing better value and reduced environmental impact.",
//       icon: <Clock size={24} />,
//       color: "bg-green-500"
//     },
//     {
//       id: 3,
//       title: "Health Protection",
//       description: "Removes harmful contaminants while preserving beneficial minerals, resulting in healthier, better tasting water.",
//       icon: <Shield size={24} />,
//       color: "bg-purple-500"
//     },
//     {
//       id: 4,
//       title: "Customer Satisfaction",
//       description: "With over 50,000 happy customers across Australia, our track record speaks for itself.",
//       icon: <Heart size={24} />,
//       color: "bg-pink-500"
//     }
//   ];

//   // FAQ data
//   const faqs = [
//     {
//       question: "How often do I need to replace the filters?",
//       answer: "Our primary filters typically last 12-18 months, depending on your water usage and local water quality. The system includes an indicator that will let you know when it's time for a replacement."
//     },
//     {
//       question: "Is installation included with purchase?",
//       answer: "Yes, professional installation is included with all whole-house systems. For under-sink models, we provide detailed DIY installation guides, but professional installation is available for an additional fee."
//     },
//     {
//       question: "Will a water filtration system affect my water pressure?",
//       answer: "Our systems are designed to minimize pressure drop. Most customers experience no noticeable difference in water pressure after installation."
//     },
//     {
//       question: "Are your filters certified?",
//       answer: "Yes, all our filtration systems are independently tested and certified to meet or exceed Australian water quality standards."
//     }
//   ];

//   // Water quality stats
//   const waterStats = [
//     { label: "Chemicals in tap water", value: "up to 50+" },
//     { label: "Chlorine removal", value: "99.9%" },
//     { label: "Heavy metals filtered", value: "99.8%" },
//     { label: "Microplastics removed", value: "99.9%" }
//   ];

//   // Counter for animation
//   const [count, setCount] = useState(0);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setCount(prevCount => (prevCount + 1) % testimonials.length);
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, [count, testimonials.length]);

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Navigation */}
//       <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-2' : 'bg-transparent py-4'}`}>
//         <div className="max-w-7xl mx-auto px-6 md:px-12">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center">
//               <a href="#" className="flex items-center">
//                 <div className={`${scrolled ? 'bg-blue-500' : 'bg-white'} rounded-full p-2 mr-2 transition-all duration-300`}>
//                   <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${scrolled ? 'text-white' : 'text-blue-500'} transition-all duration-300`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//                   </svg>
//                 </div>
//                 <div>
//                   <h1 className={`text-xl font-bold transition-all duration-300 ${scrolled ? 'text-blue-500' : 'text-white'}`}>Home Water Filtration</h1>
//                   <p className={`text-xs transition-all duration-300 ${scrolled ? 'text-gray-500' : 'text-blue-100'}`}>Pure, clean water for you</p>
//                 </div>
//               </a>
//             </div>

//             {/* Desktop Navigation */}
//             <div className="hidden md:flex items-center space-x-8">
//               <a href="#" className={`transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>Home</a>
//               <div className="relative group">
//                 <button className={`flex items-center transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>
//                   About us <ChevronDown size={16} className="ml-1" />
//                 </button>
//                 <div className="absolute hidden group-hover:block bg-white shadow-lg rounded-xl p-2 mt-2 z-10 min-w-max">
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Our Story</a>
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Mission</a>
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Team</a>
//                 </div>
//               </div>
//               <div className="relative group">
//                 <button className={`flex items-center transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>
//                   Our Products <ChevronDown size={16} className="ml-1" />
//                 </button>
//                 <div className="absolute hidden group-hover:block bg-white shadow-lg rounded-xl p-2 mt-2 z-10 min-w-max">
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Whole House Systems</a>
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Under-Sink Filters</a>
//                   <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 rounded-lg">Replacement Parts</a>
//                 </div>
//               </div>
//               <a href="#" className={`transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>Shop</a>
//               <a href="#" className={`transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>Contact Us</a>
//               <a href="#" className={`px-4 py-2 rounded-full font-medium transition-all duration-300 ${scrolled ? 'bg-blue-500 text-white hover:bg-blue-600' : 'bg-white text-blue-500 hover:bg-blue-50'}`}>
//                 Request a Quote
//               </a>
//               <a href="#" className={`transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}>
//                 <ShoppingCart size={20} />
//               </a>
//             </div>

//             {/* Mobile menu button */}
//             <div className="md:hidden">
//               <button
//                 onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//                 className={`transition-all duration-300 ${scrolled ? 'text-gray-800 hover:text-blue-500' : 'text-white hover:text-blue-100'}`}
//               >
//                 {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//               </button>
//             </div>
//           </div>

//           {/* Mobile menu */}
//           {mobileMenuOpen && (
//             <div className="md:hidden mt-4 bg-white rounded-xl shadow-lg p-4 animate-fadeDown">
//               <a href="#" className="block text-gray-800 hover:bg-blue-50 py-2 px-4 rounded-lg">Home</a>
//               <a href="#" className="block text-gray-800 hover:bg-blue-50 py-2 px-4 rounded-lg">About us</a>
//               <a href="#" className="block text-gray-800 hover:bg-blue-50 py-2 px-4 rounded-lg">Our Products</a>
//               <a href="#" className="block text-gray-800 hover:bg-blue-50 py-2 px-4 rounded-lg">Shop</a>
//               <a href="#" className="block text-gray-800 hover:bg-blue-50 py-2 px-4 rounded-lg">Contact Us</a>
//               <a href="#" className="block bg-blue-500 text-white px-4 py-2 rounded-lg font-medium mt-2">Request a Quote</a>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <div className="relative bg-gradient-to-br from-blue-600 to-blue-400 overflow-hidden pt-32 pb-16 md:pt-48 md:pb-24">
//         <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
//           <div className="flex flex-col md:flex-row items-center">
//             <div className="md:w-1/2 mb-12 md:mb-0">
//               <h1 className="text-white text-5xl md:text-7xl font-extrabold mb-6 leading-tight">
//                 HOME WATER <span className="text-blue-100">FILTRATION.</span>
//               </h1>
//               <h2 className="text-blue-100 text-2xl md:text-3xl mb-8">A water filter with a difference</h2>
//               <div className="flex flex-wrap gap-4">
//                 <button className="bg-white text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center">
//                   Request A Quote <ArrowRight size={18} className="ml-2" />
//                 </button>
//                 <button className="border-2 border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white hover:text-blue-500 transition-all">
//                   Learn More
//                 </button>
//               </div>
              
//               <div className="mt-12 flex items-center space-x-8">
//                 <div className="flex items-center">
//                   <div className="bg-blue-100 bg-opacity-20 p-2 rounded-full">
//                     <Check size={16} className="text-white" />
//                   </div>
//                   <span className="ml-2 text-blue-100">Australian Made</span>
//                 </div>
//                 <div className="flex items-center">
//                   <div className="bg-blue-100 bg-opacity-20 p-2 rounded-full">
//                     <Check size={16} className="text-white" />
//                   </div>
//                   <span className="ml-2 text-blue-100">5-Year Warranty</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="md:w-1/2 relative">
//               <div className="relative z-10 bg-white p-4 rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-all duration-300">
//                 <img 
//                   src="/api/placeholder/600/400" 
//                   alt="Advanced Water Filtration System" 
//                   className="rounded-xl"
//                 />
//                 <div className="absolute -bottom-4 -right-4 bg-blue-500 text-white px-4 py-2 rounded-full font-bold shadow-lg">
//                   NEW
//                 </div>
//               </div>
//               <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-blue-300 rounded-full opacity-20 blur-2xl"></div>
//               <div className="absolute -top-12 -left-12 w-48 h-48 bg-blue-200 rounded-full opacity-20 blur-xl"></div>
//             </div>
//           </div>
//         </div>
        
//         {/* Wave effect */}
//         <div className="absolute bottom-0 left-0 right-0">
//           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
//             <path fill="white" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,154.7C672,192,768,224,864,213.3C960,203,1056,149,1152,117.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
//           </svg>
//         </div>
//       </div>

//       {/* Stats Section */}
//       <div className="py-16 px-6 md:px-12 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
//             {waterStats.map((stat, index) => (
//               <div key={index} className="bg-blue-50 p-6 rounded-2xl text-center transform hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
//                 <p className="text-blue-500 text-4xl font-bold mb-2">{stat.value}</p>
//                 <p className="text-gray-600">{stat.label}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Info Section */}
//       <div className="py-24 px-6 md:px-12 bg-gray-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Your Health Matters</span>
//             <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Do you know what's in your tap water?</h2>
//             <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
//               In Australia we have up to 50 chemicals added to our water. While this is essential to 
//               make water safe to drink, some contaminants like chlorine and aluminium can 
//               cause health issues over time.
//             </p>
//           </div>

//           <div className="flex flex-col md:flex-row items-center gap-16">
//             <div className="md:w-1/2">
//               <div className="relative">
//                 <div className="absolute -top-6 -left-6 w-64 h-64 bg-blue-200 rounded-full opacity-20 blur-xl"></div>
//                 <div className="relative z-10">
//                   <img 
//                     src="/api/placeholder/600/400" 
//                     alt="People concerned about water quality" 
//                     className="rounded-2xl shadow-xl"
//                   />
//                 </div>
//                 <div className="absolute -bottom-4 -right-4 bg-blue-500 text-white p-4 rounded-full shadow-lg">
//                   <Droplet size={24} />
//                 </div>
//               </div>
//             </div>

//             <div className="md:w-1/2 mt-12 md:mt-0">
//               <div className="bg-white p-8 rounded-2xl shadow-lg">
//                 <div className="inline-block mb-6 p-3 bg-blue-100 text-blue-500 rounded-2xl">
//                   <Shield size={24} />
//                 </div>
//                 <h3 className="text-gray-800 text-2xl font-bold mb-4">
//                   Health impacts of untreated tap water
//                 </h3>
//                 <div className="space-y-4 mb-6">
//                   <div className="flex items-start">
//                     <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
//                       <div className="w-2 h-2 bg-red-500 rounded-full"></div>
//                     </div>
//                     <p className="text-gray-700">Behavioural problems and mental health issues</p>
//                   </div>
//                   <div className="flex items-start">
//                     <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
//                       <div className="w-2 h-2 bg-red-500 rounded-full"></div>
//                     </div>
//                     <p className="text-gray-700">Hypertension and other cardiovascular concerns</p>
//                   </div>
//                   <div className="flex items-start">
//                     <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
//                       <div className="w-2 h-2 bg-red-500 rounded-full"></div>
//                     </div>
//                     <p className="text-gray-700">Learning difficulties and cognitive impairment</p>
//                   </div>
//                   <div className="flex items-start">
//                     <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
//                       <div className="w-2 h-2 bg-red-500 rounded-full"></div>
//                     </div>
//                     <p className="text-gray-700">Dry skin, brittle hair, and skin irritation</p>
//                   </div>
//                 </div>
//                 <p className="text-gray-600 mb-6">
//                   Additionally, calcium and limescale build-up reduces appliance lifespan and requires harsh cleaning chemicals that harm our environment.
//                 </p>
//                 <button className="bg-blue-500 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-600 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-1 flex items-center">
//                   Protect Your Family <ArrowRight size={18} className="ml-2" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Features Section */}
//       <div className="py-24 px-6 md:px-12 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Advanced Technology</span>
//             <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Why Choose Our Water Filters?</h2>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               Our cutting-edge filtration systems provide the purest water possible while being environmentally friendly and cost-effective.
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {features.map((feature) => (
//               <div key={feature.id} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//                 <div className={`${feature.color} text-white p-4 rounded-xl mb-6`}>
//                   {feature.icon}
//                 </div>
//                 <h3 className="text-gray-800 text-xl font-bold mb-3">{feature.title}</h3>
//                 <p className="text-gray-600">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Product Showcase */}
//       <div className="py-24 px-6 md:px-12 bg-gray-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Our Solutions</span>
//             <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Featured Products</h2>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               Discover our range of advanced water filtration systems designed to meet your specific needs.
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {products.map((product) => (
//               <div key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//                 <div className="relative">
//                   <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
//                   <div className="absolute top-4 right-4 bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
//                     Best Seller
//                   </div>
//                 </div>
//                 <div className="p-6">
//                   <div className="flex mb-2">
//                     {[...Array(5)].map((_, i) => (
//                       <svg key={i} className={`w-4 h-4 ${i < product.rating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                       </svg>
//                     ))}
//                     <span className="text-gray-500 text-xs ml-2">({product.reviewCount} reviews)</span>
//                   </div>
//                   <h3 className="text-gray-800 text-xl font-bold mb-2">{product.name}</h3>
//                   <p className="text-blue-500 font-bold text-xl mb-4">{product.price}</p>
//                   <div className="flex items-center justify-between">
//                     <button className="bg-blue-500 text-white px-4 py-2 rounded-full font-medium hover:bg-blue-600 transition-all">
//                       Add to Cart
//                     </button>
//                     <button className="text-blue-500 font-medium hover:underline">
//                       Details
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
          
//           <div className="text-center mt-12">
//             <button className="border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all flex items-center mx-auto">
//               View All Products <ArrowRight size={18} className="ml-2" />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Testimonials Section */}
//       <div className="py-24 px-6 md:px-12 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Customer Stories</span>
//             <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">What Our Customers Say</h2>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               Thousands of Australian families have transformed their water quality with our systems.
//             </p>
//           </div>
          
//           <div className="relative bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg overflow-hidden">
//             <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-300 via-blue-500 to-purple-500"></div>
//             <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-blue-100 rounded-full opacity-30 blur-3xl"></div>
            
//             <div className="flex flex-col md:flex-row items-center md:items-start gap-8 relative z-10">
//               <div className="md:w-1/3 flex justify-center">
//                 <div className="bg-white p-2 rounded-full shadow-lg">
//                   <div className="rounded-full overflow-hidden w-24 h-24">
//                     <img src={testimonials[count].avatar} alt={testimonials[count].name} className="w-full h-full object-cover" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//         </div>
//         </div>
//         </div>  

//         </div>

//   )
// }

import { useState, useEffect } from 'react';
import { ShoppingCart, ChevronDown, Menu, X, ArrowRight, Check, Droplet, Shield, Clock, Heart, User, Mail, Phone, MapPin } from 'lucide-react';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import homewater from '../assets/homewater.jpg';
import water2 from '../assets/water3.jpg';

export default function HomeWaterFiltration() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  // Handle scroll effect on navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Product data
  const products = [
    {
      id: 1,
      name: "Whole House Filtration System",
      price: "$1,999",
      image: "/api/placeholder/400/250",
      rating: 5,
      reviewCount: 124
    },
    {
      id: 2,
      name: "Under-Sink Advanced Filter",
      price: "$499",
      image: "/api/placeholder/400/250",
      rating: 4.8,
      reviewCount: 89
    },
    {
      id: 3,
      name: "Shower Filter System",
      price: "$129",
      image: "/api/placeholder/400/250",
      rating: 4.9,
      reviewCount: 216
    }
  ];

  // Testimonial data
  const testimonials = [
    {
      id: 1,
      text: "The difference in water quality is incredible. My skin has never felt better, and our appliances are free from limescale buildup for the first time!",
      name: "Sarah Johnson",
      location: "Brisbane",
      rating: 5,
      avatar: "/api/placeholder/64/64"
    },
    {
      id: 2,
      text: "Installation was straightforward, and the customer support team was exceptional. They guided me through every step, making the process hassle-free.",
      name: "Michael Chen",
      location: "Sydney",
      rating: 5,
      avatar: "/api/placeholder/64/64"
    },
    {
      id: 3,
      text: "Our water tastes incredible now! We've eliminated plastic bottle waste and are saving money while enjoying healthier water. Highly recommended!",
      name: "Lisa Anderson",
      location: "Melbourne",
      rating: 5,
      avatar: "/api/placeholder/64/64"
    }
  ];

  // Features data
  const features = [
    {
      id: 1,
      title: "Advanced Filtration Technology",
      description: "Our proprietary multi-stage filtration system removes 99.9% of contaminants including chlorine, heavy metals, and microplastics.",
      icon: <Droplet size={24} />,
      color: "bg-blue-500"
    },
    {
      id: 2,
      title: "Superior Longevity",
      description: "Designed to last 2-3 times longer than competing products, providing better value and reduced environmental impact.",
      icon: <Clock size={24} />,
      color: "bg-green-500"
    },
    {
      id: 3,
      title: "Health Protection",
      description: "Removes harmful contaminants while preserving beneficial minerals, resulting in healthier, better tasting water.",
      icon: <Shield size={24} />,
      color: "bg-purple-500"
    },
    {
      id: 4,
      title: "Customer Satisfaction",
      description: "With over 50,000 happy customers across Australia, our track record speaks for itself.",
      icon: <Heart size={24} />,
      color: "bg-pink-500"
    }
  ];

  // FAQ data
  const faqs = [
    {
      question: "How often do I need to replace the filters?",
      answer: "Our primary filters typically last 12-18 months, depending on your water usage and local water quality. The system includes an indicator that will let you know when it's time for a replacement."
    },
    {
      question: "Is installation included with purchase?",
      answer: "Yes, professional installation is included with all whole-house systems. For under-sink models, we provide detailed DIY installation guides, but professional installation is available for an additional fee."
    },
    {
      question: "Will a water filtration system affect my water pressure?",
      answer: "Our systems are designed to minimize pressure drop. Most customers experience no noticeable difference in water pressure after installation."
    },
    {
      question: "Are your filters certified?",
      answer: "Yes, all our filtration systems are independently tested and certified to meet or exceed Australian water quality standards."
    }
  ];

  // Water quality stats
  const waterStats = [
    { label: "Chemicals in tap water", value: "up to 50+" },
    { label: "Chlorine removal", value: "99.9%" },
    { label: "Heavy metals filtered", value: "99.8%" },
    { label: "Microplastics removed", value: "99.9%" }
  ];

  // Counter for animation
  const [count, setCount] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setCount(prevCount => (prevCount + 1) % testimonials.length);
    }, 5000);
    return () => clearTimeout(timer);
  }, [count, testimonials.length]);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
     <NavBar />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-blue-600 to-blue-400 overflow-hidden pt-32 pb-16 md:pt-48 md:pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-12 md:mb-0">
              <h1 className="text-white text-5xl md:text-7xl font-extrabold mb-6 leading-tight">
                HOME WATER <span className="text-blue-100">FILTRATION.</span>
              </h1>
              <h2 className="text-blue-100 text-2xl md:text-3xl mb-8">A water filter with a difference</h2>
              <div className="flex flex-wrap gap-4">
                <button className="bg-white text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center">
                 <a href='/contact'> Request A Quote </a>
                </button>
                
              </div>
              
              {/* <div className="mt-12 flex items-center space-x-8">
                <div className="flex items-center">
                  <div className="bg-blue-100 bg-opacity-20 p-2 rounded-full">
                    <Check size={16} className="text-white" />
                  </div>
                  <span className="ml-2 text-blue-100">Australian Made</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 bg-opacity-20 p-2 rounded-full">
                    <Check size={16} className="text-white" />
                  </div>
                  <span className="ml-2 text-blue-100">5-Year Warranty</span>
                </div>
              </div> */}
            </div>
            
            <div className="md:w-1/2 relative">
              <div className="relative z-10 bg-white p-4 rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-all duration-300">
                <img 
                  src={homewater} 
                  alt="Advanced Water Filtration System" 
                  className="rounded-xl"
                />
                <div className="absolute -bottom-4 -right-4 bg-blue-500 text-white px-4 py-2 rounded-full font-bold shadow-lg">
                  NEW
                </div>
              </div>
              <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-blue-300 rounded-full opacity-20 blur-2xl"></div>
              <div className="absolute -top-12 -left-12 w-48 h-48 bg-blue-200 rounded-full opacity-20 blur-xl"></div>
            </div>
          </div>
        </div>
        
        {/* Wave effect */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
            <path fill="white" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,154.7C672,192,768,224,864,213.3C960,203,1056,149,1152,117.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </div>

      {/* Stats Section */}
      <div className="py-16 px-6 md:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {waterStats.map((stat, index) => (
              <div key={index} className="bg-blue-50 p-6 rounded-2xl text-center transform hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
                <p className="text-blue-500 text-4xl font-bold mb-2">{stat.value}</p>
                <p className="text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Info Section */}
      <div className="py-24 px-6 md:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Your Health Matters</span>
            <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Do you know what's in your tap water?</h2>
            <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
              In Australia we have up to 50 chemicals added to our water. While this is essential to 
              make water safe to drink, some contaminants like chlorine and aluminium can 
              cause health issues over time.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-16">
            <div className="md:w-1/2">
              <div className="relative">
                <div className="absolute -top-6 -left-6 w-64 h-64 bg-blue-200 rounded-full opacity-20 blur-xl"></div>
                <div className="relative z-10">
                  <img 
                    src={water2} 
                    alt="People concerned about water quality" 
                    className="rounded-2xl shadow-xl"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-blue-500 text-white p-4 rounded-full shadow-lg">
                  <Droplet size={24} />
                </div>
              </div>
            </div>

            <div className="md:w-1/2 mt-12 md:mt-0">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="inline-block mb-6 p-3 bg-blue-100 text-blue-500 rounded-2xl">
                  <Shield size={24} />
                </div>
                <h3 className="text-gray-800 text-2xl font-bold mb-4">
                  Health impacts of untreated tap water
                </h3>
                <div className="space-y-4 mb-6">
                  <div className="flex items-start">
                    <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    </div>
                    <p className="text-gray-700">Behavioural problems and mental health issues</p>
                  </div>
                  <div className="flex items-start">
                    <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    </div>
                    <p className="text-gray-700">Hypertension and other cardiovascular concerns</p>
                  </div>
                  <div className="flex items-start">
                    <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    </div>
                    <p className="text-gray-700">Learning difficulties and cognitive impairment</p>
                  </div>
                  <div className="flex items-start">
                    <div className="bg-red-100 p-1 rounded-full mr-3 mt-1">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    </div>
                    <p className="text-gray-700">Dry skin, brittle hair, and skin irritation</p>
                  </div>
                </div>
                <p className="text-gray-600 mb-6">
                  Additionally, calcium and limescale build-up reduces appliance lifespan and requires harsh cleaning chemicals that harm our environment.
                </p>
                <button className="bg-blue-500 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-600 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-1 flex items-center">
                  Protect Your Family <ArrowRight size={18} className="ml-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-24 px-6 md:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Advanced Technology</span>
            <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Why Choose Our Water Filters?</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Our cutting-edge filtration systems provide the purest water possible while being environmentally friendly and cost-effective.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature) => (
              <div key={feature.id} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className={`${feature.color} text-white p-4 rounded-xl mb-6`}>
                  {feature.icon}
                </div>
                <h3 className="text-gray-800 text-xl font-bold mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Showcase */}
      {/* <div className="py-24 px-6 md:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Our Solutions</span>
            <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Featured Products</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Discover our range of advanced water filtration systems designed to meet your specific needs.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {products.map((product) => (
              <div key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="relative">
                  <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
                  <div className="absolute top-4 right-4 bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
                    Best Seller
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex mb-2">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className={`w-4 h-4 ${i < product.rating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                    <span className="text-gray-500 text-xs ml-2">({product.reviewCount} reviews)</span>
                  </div>
                  <h3 className="text-gray-800 text-xl font-bold mb-2">{product.name}</h3>
                  <p className="text-blue-500 font-bold text-xl mb-4">{product.price}</p>
                  <div className="flex items-center justify-between">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-full font-medium hover:bg-blue-600 transition-all">
                      Add to Cart
                    </button>
                    <button className="text-blue-500 font-medium hover:underline">
                      Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button className="border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all flex items-center mx-auto">
              View All Products <ArrowRight size={18} className="ml-2" />
            </button>
          </div>
        </div>
      </div> */}

      {/* Testimonials Section */}
      {/* <div className="py-24 px-6 md:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Customer Stories</span>
            <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">What Our Customers Say</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Thousands of Australian families have transformed their water quality with our systems.
            </p>
          </div>
          
          <div className="relative bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-300 via-blue-500 to-purple-500"></div>
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-blue-100 rounded-full opacity-30 blur-3xl"></div>
            
            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 relative z-10">
              <div className="md:w-1/3 flex justify-center">
                <div className="bg-white p-2 rounded-full shadow-lg">
                  <div className="rounded-full overflow-hidden w-24 h-24">
                    <img src={testimonials[count].avatar} alt={testimonials[count].name} className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
              
              <div className="md:w-2/3">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                          </svg>
                    ))}
                  </div>
                  <p className="text-gray-700 text-lg italic mb-6">"{testimonials[count].text}"</p>
                  <div>
                    <p className="text-gray-800 font-bold">{testimonials[count].name}</p>
                    <p className="text-gray-500">{testimonials[count].location}</p>
                  </div>
                </div>
              </div>
              
              <div className="flex justify-center mt-8 space-x-2">
                {testimonials.map((_, index) => (
                  <button 
                    key={index}
                    onClick={() => setCount(index)}
                    className={`w-3 h-3 rounded-full transition-all ${index === count ? 'bg-blue-500 w-6' : 'bg-gray-300'}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div> */}

        {/* FAQ Section */}
        <div className="py-24 px-6 md:px-12 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <span className="bg-blue-100 text-blue-500 px-4 py-1 rounded-full text-sm font-medium">Have Questions?</span>
              <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mt-4 mb-6">Frequently Asked Questions</h2>
              <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                Here are some common questions about our water filtration systems.
              </p>
            </div>
            
            <div className="max-w-4xl mx-auto">
              {faqs.map((faq, index) => (
                <div key={index} className="mb-6">
                  <button 
                    onClick={() => setActiveTab(activeTab === index ? null : index)}
                    className="flex items-center justify-between w-full text-left bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-all"
                  >
                    <h3 className="text-gray-800 font-bold text-lg">{faq.question}</h3>
                    <ChevronDown 
                      size={20} 
                      className={`text-gray-500 transition-transform duration-300 ${activeTab === index ? 'transform rotate-180' : ''}`}
                    />
                  </button>
                  {activeTab === index && (
                    <div className="bg-white p-6 rounded-b-2xl shadow-md -mt-2">
                      <p className="text-gray-600">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="py-24 px-6 md:px-12 bg-gradient-to-r from-blue-500 to-blue-600">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-white text-3xl md:text-5xl font-bold mb-6">Ready for Cleaner, Healthier Water?</h2>
            <p className="text-blue-100 text-xl mb-8 max-w-3xl mx-auto">
              Join thousands of Australian families who have transformed their water quality with our advanced filtration systems.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button className="bg-white text-blue-500 px-8 py-4 rounded-full font-bold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center">
               <a href='/contact'> Request A Free Consultation</a>
              </button>
              {/* <button className="border-2 border-white text-white px-8 py-4 rounded-full font-bold hover:bg-white hover:text-blue-500 transition-all">
                Call Us: 1300 123 456
              </button> */}
            </div>
          </div>
        </div>

        {/* Footer */}
      <Footer />
      </div>
   
  );
}